import { lazy, Suspense, type ReactNode } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { StorageProvider } from './persistence/StorageContext'
import { AuthCallbackPage } from './auth/AuthCallbackPage'
import { AuthPage } from './auth/AuthPage'
import { ProtectedRoute } from './auth/ProtectedRoute'
import { WebMcpBridge } from './components/WebMcpBridge'
import { HomeRoute } from './public/routes/HomeRoute'
import { LoadingState } from './routes/components/LoadingState'

// Studio and public pages are split so the landing page and player never download the editor.
const ProjectsRoute = lazy(() =>
  import('./routes/ProjectsRoute').then((m) => ({ default: m.ProjectsRoute })),
)
const ProjectEditorRoute = lazy(() =>
  import('./routes/ProjectEditorRoute').then((m) => ({ default: m.ProjectEditorRoute })),
)
const SettingsRoute = lazy(() =>
  import('./routes/SettingsRoute').then((m) => ({ default: m.SettingsRoute })),
)
const PlayRoute = lazy(() =>
  import('./public/routes/PlayRoute').then((m) => ({ default: m.PlayRoute })),
)
const EmbedRoute = lazy(() =>
  import('./public/routes/EmbedRoute').then((m) => ({ default: m.EmbedRoute })),
)

const studio = (page: ReactNode) => (
  <ProtectedRoute>
    <Suspense fallback={<LoadingState />}>{page}</Suspense>
  </ProtectedRoute>
)

const publicPage = (page: ReactNode) => (
  <Suspense fallback={<div style={{ position: 'fixed', inset: 0, background: '#050713' }} />}>
    {page}
  </Suspense>
)

const router = createBrowserRouter([
  { path: '/auth', element: <AuthPage /> },
  { path: '/auth/callback', element: <AuthCallbackPage /> },
  { path: '/', element: <HomeRoute /> },
  { path: '/play/:slug', element: publicPage(<PlayRoute />) },
  { path: '/embed/:slug', element: publicPage(<EmbedRoute />) },
  { path: '/projects', element: studio(<ProjectsRoute />) },
  { path: '/projects/:id', element: studio(<ProjectEditorRoute />) },
  { path: '/settings', element: studio(<SettingsRoute />) },
])

export function App() {
  return (
    <StorageProvider>
      <WebMcpBridge />
      <RouterProvider router={router} />
    </StorageProvider>
  )
}
